
export type MiniHookPosition =
  | 'top-left' | 'top-center' | 'top-right'
  | 'middle-left' | 'center' | 'middle-right'
  | 'bottom-left' | 'bottom-center' | 'bottom-right';

export interface MiniHook {
  id: string;
  name: string;
  fileUrl: string;
  fileType: 'image' | 'gif';
  fileName?: string;
  startTimeSeconds: number;
  endTimeSeconds: number;
  opacity: number;
  position: MiniHookPosition;
  widthPercent: number;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface MiniHookSettings {
  enabled: boolean;
  hooks: MiniHook[];
}

export const defaultMiniHookSettings: MiniHookSettings = {
  enabled: false,
  hooks: [],
};
